import { createPortal } from 'react-dom';

/**
 * Rend ses enfants dans un portail attaché à `<body>`.
 *
 * Indispensable aux modales `position: fixed` déclenchées depuis l'en-tête :
 * celui-ci porte `backdrop-blur` (donc `backdrop-filter`), ce qui établit un
 * BLOC CONTENEUR pour ses descendants `fixed`. Sans portail, une modale
 * `fixed inset-0` est bornée à la boîte de l'en-tête (haute d'environ 56 px) au
 * lieu du viewport — elle s'ouvre « dans la frame du haut ». Le portail sort la
 * modale de cet ancêtre : `inset-0` retrouve le viewport plein écran.
 */
export function Portal({ children }: { children: React.ReactNode }): React.ReactPortal {
  return createPortal(children, document.body);
}
